/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

const IconLinkContext = createContext(null);

export { IconLinkContext };
